import {memo} from "react";

export const ShopBanner = memo(({shopBannerContent}) => {
    if (shopBannerContent && shopBannerContent.length > 0) {
        return (
            <div className="dp__header__shop-banner" dangerouslySetInnerHTML={{__html: shopBannerContent}}/>
        )
    }
    return null;
})